'use client';

import Icon from './Icon';
import svg from 'sprites/logo.svg';

export default function IconLogo({
  className = 'w-15 h-15 md:w-17 md:h-17 fill-white stroke-none'
}: {
  className?: string;
}) {
  return <Icon id={svg.id} className={className} />;
}
